export default "https://legacy.eskolare.com/images/abo2o.png";